import { getAddonManagementFormQuoteDetails } from 'state/addonManagementForm/quoteDetails/quoteDetails.selectors';
import * as fromQuoteResult from 'state/quotes/results/results.selectors';
import type { AppState } from 'state/state.model';

export function getAddonManagementFormQuoteResult(state: AppState, formId: string) {
  const quoteId = state.addonManagementForm?.infos[formId].lastQuoteId;
  return quoteId ? fromQuoteResult.getQuoteResult(state.quotes.results, quoteId) : undefined;
}
export function getAddonManagementFormTradeResult(state: AppState, formId: string) {
  const quoteId = state.addonManagementForm?.infos[formId].lastQuoteId;
  return quoteId ? state.quotes.trades[quoteId] : undefined;
}
export function getAddonManagementFormResult(state: AppState, formId: string) {
  const quoteDetails = getAddonManagementFormQuoteDetails(state, formId);
  const quoteResults = getAddonManagementFormQuoteResult(state, formId);

  return {
    ...(quoteResults?.quoteExternalId && { QuoteExternalId: quoteResults?.quoteExternalId }),
    ...(quoteResults?.pricingTime && { PricingTime: quoteResults?.pricingTime }),
    ...(quoteDetails?.PricerRfqId && { TessaId: quoteDetails?.PricerRfqId }),
    ...(quoteDetails?.Greeks && { SpotAndGreeks: quoteDetails?.Greeks }),
    ...(quoteDetails?.Underlyings && { Underlyings: quoteDetails?.Underlyings }),
  };
}
